import React from 'react';
import styled from 'styled-components';

interface ICheckIconProps {
  color?: string;
}

const StyledSvg = styled.svg<ICheckIconProps>`
  display: block;

  path {
    fill: ${({ color, theme }) =>
      color ? color : theme.colors.cross.greenMint};
  }
`;

const Check = ({ color }: ICheckIconProps): JSX.Element => (
  <StyledSvg
    color={color}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="3.83 6.01 16.75 12.57"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 16.17L5.53 12.7a.996.996 0 10-1.41 1.41l4.18 4.18c.39.39 1.02.39 1.41 0L20.29 7.71a.996.996 0 10-1.41-1.41L9 16.17z"
      fill="#020202"
    />
  </StyledSvg>
);

export default Check;
